import { Injectable } from '@angular/core';
import {
    MatSnackBar,
    MatSnackBarConfig,
    MatSnackBarRef
} from '@angular/material/snack-bar';
import { INotificationResponseModel } from 'src/app/modules/notifications/interfaces/notification-response-model';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    initConfig: MatSnackBarConfig = {
        verticalPosition: 'top',
        horizontalPosition: 'center',
        duration: 2500,
        panelClass: 'center-margin'
    };

    constructor(private snackBar: MatSnackBar) {}

    Show(_message: string, _action?: string, _config?: MatSnackBarConfig) {
        this.snackBar.open(
            _message,
            _action,
            !_config ? this.initConfig : _config
        );
    }

    showPopup(
        component: any,
        notification: INotificationResponseModel
    ): MatSnackBarRef<any> {
        // Needs to be in milliseconds
        return this.snackBar.openFromComponent(component, {
            duration: notification.displayTimeSeconds * 1000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['white-snackbar'],
            data: notification
        });
    }
}
